import { render, staticRenderFns } from "./CreateLoadingModal.vue?vue&type=template&id=f70c393a&lang=pug&"
import script from "./CreateLoadingModal.vue?vue&type=script&lang=js&"
export * from "./CreateLoadingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports